import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import HeadingSample from "../components/utility/headingSample";
import { motion } from "framer-motion";
import { PiTelegramLogoLight } from "react-icons/pi";
import { FiFacebook, FiLinkedin, FiTwitter } from "react-icons/fi";
const sec1Subtitle = "Get help from us";
const sec1Title = ["contact us", "#F8D835"];

const Contact_Us: React.FC = () => {
  const form = useRef<HTMLFormElement>(null);
  const [isSending, setIsSending] = useState(false);
  const [buttonText, setButtonText] = useState("Send Message");

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.current) return;

    setIsSending(true);
    setButtonText("Sending...");

    emailjs
      .sendForm(
        "service_mineralex",   // Replace with actual
        "template_qa3ccng",    // Replace with actual
        form.current,
        "iyNgeWWHge6K5wl66"     // Replace with actual
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current?.reset();
          setButtonText("Send Message");
        },
        (error) => {
          alert("Something went wrong. Try again.");
          console.error(error.text);
          setButtonText("Send Message");
        }
      )
      .finally(() => setIsSending(false));
  };

  return (
    <div className="w-full flex flex-col items-center justify-center bg-white box-border overflow-hidden">
      <motion.div
        id="contact_Us_Home"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="h-[500px] sm:h-[700px] w-full bg-[url('../public/contact_Us/section1.svg')] bg-black/30 bg-blend-overlay bg-cover bg-center"
      >
        <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
      </motion.div>

      <div id="send_Message" className="w-full bg-[#fdf8f1] px-2 py-20">

        <div className="w-full max-w-7xl mx-auto flex flex-col justify-center items-center">
          <img
            src="/contact_Us/bridge.png"
            alt="Bridge Illustration"
            className="w-full max-w-5xl mx-auto rounded-md"
          />
          <div className="w-full flex flex-col md:flex-row justify-center items-center gap-8">
            <img
              src="/contact_Us/mining.png"
              alt="Bridge Illustration"
              className="w-full rounded-md"
            />
            <div className="w-full bg-white p-6 rounded-lg shadow-md ">

              <div className="w-full flex flex-col justify-center items-center gap-4">
                <form ref={form} onSubmit={sendEmail} className="w-full flex flex-col gap-4">
                  <input
                    name="email"
                    type="email"
                    placeholder="Email"
                    className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  />
                  <input
                    name="name"
                    type="text"
                    placeholder="Full Name"
                    className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  />
                  <input
                    name="country"
                    type="text"
                    placeholder="Country"
                    className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  />
                  <textarea
                    name="message"
                    placeholder="Message"
                    rows={4}
                    className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  ></textarea>
                  <button
                    type="submit"
                    disabled={isSending}
                    className={`${isSending ? "bg-gray-400 cursor-not-allowed" : "bg-[#1C2D5A] hover:bg-[#8a936d80] active:bg-[#babd8a]"
                      } mt-2 bg-orange-500 text-white py-2 rounded-lg hover:bg-orange-600 transition-colors`}
                  >
                    {buttonText}
                  </button>
                </form>
                <div className="w-full flex flex-row justify-around items-center gap-2">
                  <a href={process.env.REACT_APP_Telegram_link} >
                    <div className="w-fit bg-inherit hover:bg-yellow-100 text-2xl text-black border-2 hover:font-bold hover:scale-125 border-orange-500 p-2 sm:p-3 rounded-full">
                      <PiTelegramLogoLight />
                    </div>
                  </a>
                  <a
                    href={process.env.REACT_APP_Twitter_link}
                  >
                    <div className="w-fit bg-inherit hover:bg-yellow-100 text-2xl text-black border-2 hover:font-bold hover:scale-125 border-orange-500 p-2 sm:p-3 rounded-full">
                      <FiTwitter />
                    </div>
                  </a>
                  <a href={process.env.REACT_APP_Linkedin_link} >
                    <div className="w-fit bg-inherit hover:bg-yellow-100 text-2xl text-black border-2 hover:font-bold hover:scale-125 border-orange-500 p-2 sm:p-3 rounded-full">
                      <FiLinkedin />
                    </div>
                  </a>
                  <a href={process.env.REACT_APP_Facebook_link} >
                    <div className="w-fit bg-inherit hover:bg-yellow-100 text-2xl text-black border-2 hover:font-bold hover:scale-125 border-orange-500 p-2 sm:p-3 rounded-full">
                      <FiFacebook />
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <img
              src="/contact_Us/mineralex.png"
              alt="Bridge Illustration"
              className="w-full rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact_Us;
